import styled from '@emotion/styled';
import { grayScale } from '__app/colors';
import { colorsButton } from '__app/colors';
import Input from '__components/Kizen/Input';

export const Range = styled.input<{ thumbWidth: number }>`
  -webkit-appearance: none;
  overflow: hidden;
  border-radius: 8px;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: white;
    border: 1px solid ${colorsButton.blue.default};
    height: ${({ thumbWidth }) => thumbWidth}px;
    width: ${({ thumbWidth }) => thumbWidth}px;
    border-radius: 100%;
    box-shadow: -430px 0 0 423px ${colorsButton.blue.default};
  }

  &::-webkit-slider-runnable-track {
    background-color: ${grayScale.mediumLight};
  }
`;

export const TranslatedHeader = styled.div`
  transform: translateY(-100%);
`;

export const Dots = styled.div`
  position: relative;
  height: 2px;
  overflow: hidden;

  &:after {
    content: '.....................................................................................................................................................................................................................';
    letter-spacing: 1px;
    position: absolute;
    width: 100%;
    overflow: hidden;
    top: -6px;
  }
`;

export const SmallInput = styled(Input)`
  & input {
    width: 100%;
  }
`;
